export const MAX_CONSENT_BANNER_COUNT =
  process.env.REACT_APP_MAX_CONSENT_BANNER_COUNT;
